import React from 'react';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { IKpiLookupItem } from './objectivecontract.models';
import { fetchKpiLookup } from './objectivecontract.apis';

type Props = {
  module: string;
  label: string;
  value: string;
  onChange: (recix: string, item?: IKpiLookupItem | null) => void;
  required?: boolean;
  disabled?: boolean;
  freeSolo?: boolean;
  onFreeText?: (text: string) => void;
};

export default function KpiLookupField({
  module,
  label,
  value,
  onChange,
  required,
  disabled,
  freeSolo,
  onFreeText,
}: Props) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState<IKpiLookupItem[]>([]);
  const [inputValue, setInputValue] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    let active = true;
    setLoading(true);
    fetchKpiLookup(module, inputValue, 50)
      .then((items) => {
        if (active) setOptions(items);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => { active = false; };
  }, [module, inputValue]);

  const selected = options.find((o) => o.recix === value) || null;

  return (
    <Autocomplete
      fullWidth
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      disabled={disabled}
      freeSolo={freeSolo}
      options={options}
      value={selected}
      inputValue={inputValue}
      getOptionLabel={(option: any) => typeof option === 'string' ? option : option?.recname || ''}
      isOptionEqualToValue={(option, val) => option.recix === val.recix}
      onInputChange={(_, val) => setInputValue(val)}
      onChange={(_, val: any) => {
        if (typeof val === 'string') {
          onFreeText?.(val);
          return;
        }
        onChange(val?.recix || '', val || null);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          required={required}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress size={18} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
}
